import { useQueryApi } from 'utils/api'

import type { AxiosError } from 'axios'
import type { CommonListResponse, CommonResponse } from 'types/api'
import type {
  MaterialDataResponse,
  ResponseModulData,
} from 'types/microlearning'

const basePath = '/microlearnings'

export function useGetModulePreview(
  moduleId: string,
  enabled: boolean = true,
  useErrorBoundary = true
) {
  return useQueryApi<CommonResponse<ResponseModulData>, AxiosError>(
    `${basePath}/modules/${moduleId}/preview`,
    {
      queryConfig: {
        enabled: !!moduleId && enabled,
        retry: false,
        useErrorBoundary: useErrorBoundary,
      },
    }
  )
}

export function useGetMaterialByModule(moduleId: string) {
  return useQueryApi<CommonListResponse<MaterialDataResponse>>(
    `${basePath}/modules/${moduleId}/materials`,
    {
      queryConfig: {
        enabled: !!moduleId,
        retry: false,
      },
    }
  )
}
